var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "bet-creator-btn",
      attrs: { disabled: _vm.isDisabled },
      on: { click: _vm.placeBet },
    },
    [
      !_vm.isLoading
        ? _c("span", { staticClass: "btn-text" }, [
            _vm._v(" " + _vm._s(_vm.buttonText) + " "),
          ])
        : _vm._e(),
      _vm.isLoading
        ? _c("span", { staticClass: "spinner-wrapper" }, [
            _c(
              "svg",
              {
                staticClass: "spinner-icon",
                attrs: { viewBox: "0 0 24 24", "aria-hidden": "true" },
              },
              [
                _c("circle", {
                  staticClass: "circle-bg",
                  attrs: {
                    cx: "12",
                    cy: "12",
                    r: "10",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "3",
                  },
                }),
                _c("path", {
                  staticClass: "path-fill",
                  attrs: {
                    d: "M12 2a10 10 0 0 1 10 10h-3A7 7 0 0 0 12 5V2z",
                    fill: "currentColor",
                  },
                }),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }